<template>
  <svg
    width="24"
    height="24"
    :class="customStyle"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4_25)">
      <path
        d="M6.75 2.5C7.30812 2.5 7.86077 2.60993 8.37641 2.82351C8.89204 3.03709 9.36056 3.35015 9.75521 3.7448C10.1499 4.13945 10.4629 4.60796 10.6765 5.1236C10.8901 5.63923 11 6.19188 11 6.75V11H6.75C5.62283 11 4.54183 10.5522 3.7448 9.7552C2.94777 8.95817 2.5 7.87717 2.5 6.75C2.5 5.62283 2.94777 4.54183 3.7448 3.7448C4.54183 2.94777 5.62283 2.5 6.75 2.5ZM6.75 13H11V17.25C11 18.0906 10.7507 18.9123 10.2837 19.6112C9.81675 20.3101 9.15299 20.8548 8.37641 21.1765C7.59982 21.4982 6.74529 21.5823 5.92087 21.4183C5.09645 21.2543 4.33917 20.8496 3.7448 20.2552C3.15042 19.6608 2.74565 18.9036 2.58166 18.0791C2.41768 17.2547 2.50184 16.4002 2.82351 15.6236C3.14519 14.847 3.68992 14.1833 4.38883 13.7163C5.08774 13.2493 5.90943 13 6.75 13ZM17.25 2.5C18.3772 2.5 19.4582 2.94777 20.2552 3.7448C21.0522 4.54183 21.5 5.62283 21.5 6.75C21.5 7.87717 21.0522 8.95817 20.2552 9.7552C19.4582 10.5522 18.3772 11 17.25 11H13V6.75C13 5.62283 13.4478 4.54183 14.2448 3.7448C15.0418 2.94777 16.1228 2.5 17.25 2.5ZM13 13H17.25C18.0906 13 18.9123 13.2493 19.6112 13.7163C20.3101 14.1833 20.8548 14.847 21.1765 15.6236C21.4982 16.4002 21.5823 17.2547 21.4183 18.0791C21.2544 18.9036 20.8496 19.6608 20.2552 20.2552C19.6608 20.8496 18.9036 21.2543 18.0791 21.4183C17.2547 21.5823 16.4002 21.4982 15.6236 21.1765C14.847 20.8548 14.1833 20.3101 13.7163 19.6112C13.2493 18.9123 13 18.0906 13 17.25V13Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_4_25">
        <rect
          width="24"
          height="24"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  name: 'EmissionsIcon',
  props: {
    customStyle: {
      type: String,
      default: 'h-5 w-5',
    },
  },
}
</script>
